import AuthService from "@/services/authService";
import { AiseaApiFactory } from "@/api/aisea/apiFactory";
const enterpriseAddonRepository = AiseaApiFactory.get(
  "enterpriseAddonRepository"
);

import { RadarGridApiFactory } from "@/api/radar-grid/apiFactory";
import Store from "@/store/store";
const rgObjRepository = RadarGridApiFactory.get("radarGridObjectRepository");
const rgBaseRepository = RadarGridApiFactory.get(
  "radarGridRadarBaseRepository"
);

class RadarGridService {
  async setExternalToken() {
    let res = await enterpriseAddonRepository.fetchAddons();
    let enterpriseAddons = res.data.enterprise_addons;
    const matched = enterpriseAddons.find(item => {
      return item.addon.id === AuthService.ADDON_IDS.RADAR_GRID;
    });
    let resToken = await enterpriseAddonRepository.fetchExternalToken(
      matched.id
    );

    Store.commit("auth/SET_RG_EXTERNAL_TOKEN", { token: resToken.data.token });
  }

  async fetchRadarBaseGroupId() {
    const enterpriseId = Store.getters["auth/getEnterpriseId"];
    let res = await rgBaseRepository.fetchRadarBaseGroupsByEnterpriseId(
      enterpriseId
    );
    if (res.data.radar_base_group_id) {
      Store.commit("auth/SET_RG_GROUP_ID", {
        id: res.data.radar_base_group_id,
      });
      return res.data.radar_base_group_id;
    }

    return null;
  }

  async fetchRadarGridObjects(groupId) {
    let params = {
      radar_base_group_id: groupId,
    };
    let res = await rgObjRepository.fetchRadarGridObjects(params);
    return res.data.latestRadarGridObjects;
  }

  async fetchPastPath(objectId) {
    const now = new Date();
    const endedAt = now.toISOString();
    const startedAt = new Date(
      now.getTime() - 24 * 60 * 60 * 1000
    ).toISOString();
    let params = {
      started_at: startedAt,
      ended_at: endedAt,
      interval: 30,
    };
    let res = await rgObjRepository.fetchPastPath(objectId, params);
    return res.data;
  }
}

export default new RadarGridService();
